export default __webpack_public_path__ + "static/media/noAnnounements.567df4e1.svg";